var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, HostBinding, ViewEncapsulation, Input, Output, EventEmitter, } from '@angular/core';
import { DomSanitizer, } from '@angular/platform-browser';
import { closeIcon, } from './icons';
import { translateInOut } from './animations';
var CookieLawElementComponent = (function () {
    function CookieLawElementComponent(domSanitizer) {
        this.domSanitizer = domSanitizer;
        this.isSeen = new EventEmitter();
        this.transition = 'bottomIn';
        this._position = 'bottom';
        this.cookieLawClass = true;
    }
    Object.defineProperty(CookieLawElementComponent.prototype, "learnMore", {
        get: function () { return this._learnMore; },
        set: function (value) {
            this._learnMore = (value !== null && "" + value !== 'false') ? value : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CookieLawElementComponent.prototype, "awsomeCloseIcon", {
        get: function () { return this._awsomeCloseIcon; },
        set: function (value) {
            this._awsomeCloseIcon = (value !== null && "" + value !== 'false') ? value : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CookieLawElementComponent.prototype, "target", {
        get: function () { return this._target; },
        set: function (value) {
            this._target = (value !== null && "" + value !== 'false' &&
                ("" + value === '_blank' || "" + value === '_self')) ? value : '_blank';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CookieLawElementComponent.prototype, "position", {
        get: function () { return this._position; },
        set: function (value) {
            this._position = (value !== null && "" + value !== 'false' &&
                ("" + value === 'top' || "" + value === 'bottom')) ? value : 'bottom';
        },
        enumerable: true,
        configurable: true
    });
    CookieLawElementComponent.prototype.ngOnInit = function () {
        this.noopener = this._target === '_blank';
        this.transition = this.position === 'bottom' ? 'bottomIn' : 'topIn';
        if (this._awsomeCloseIcon) {
            this.closeSvg = this.domSanitizer.bypassSecurityTrustHtml("<i class='fab " + this._awsomeCloseIcon + "'></i>");
        }
        else {
            this.closeSvg = this.domSanitizer.bypassSecurityTrustHtml(closeIcon);
        }
        this.currentStyles = {
            'top': this.position === 'top' ? '0' : null,
            'bottom': this.position === 'top' ? 'initial' : null,
        };
    };
    CookieLawElementComponent.prototype.afterDismissAnimation = function (evt) {
        if (evt.toState === 'topOut' ||
            evt.toState === 'bottomOut') {
            this.isSeen.emit(true);
        }
    };
    CookieLawElementComponent.prototype.dismiss = function (evt) {
        if (evt) {
            evt.preventDefault();
        }
        this.transition = this.position === 'top' ? 'topOut' : 'bottomOut';
    };
    return CookieLawElementComponent;
}());
__decorate([
    HostBinding('class.cookie-law'),
    __metadata("design:type", Boolean)
], CookieLawElementComponent.prototype, "cookieLawClass", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [String])
], CookieLawElementComponent.prototype, "learnMore", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [String])
], CookieLawElementComponent.prototype, "awsomeCloseIcon", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [String])
], CookieLawElementComponent.prototype, "target", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [String])
], CookieLawElementComponent.prototype, "position", null);
__decorate([
    Output(),
    __metadata("design:type", Object)
], CookieLawElementComponent.prototype, "isSeen", void 0);
CookieLawElementComponent = __decorate([
    Component({
        selector: 'cookie-law-el',
        animations: [translateInOut],
        styles: ['.cookie-law .cookie-law-wrapper {  background: #333;  color: #bbb;  display: block;  font-family: Helvetica Neue,Helvetica,Arial,sans-serif;  font-size: 15px;  font-weight: 200;  line-height: 20px;  position: fixed;  bottom: 0;  left: 0;  width: 100%;  z-index: 999999999;  font-smooth: always;  -webkit-font-smoothing: antialiased;}.cookie-law .cookie-law-wrapper a {  color: #bbb;  -webkit-transition: color .2s;  transition: color .2s;}.cookie-law .cookie-law-wrapper a:hover {  color: #fff;}.cookie-law .cookie-law-wrapper a:hover svg {  fill: #fff;}.cookie-law .cookie-law-wrapper .dismiss {  display: block;  box-sizing: border-box;  padding: 10px;  position: absolute;  top: 0;  right: 10px;  text-decoration: none;  line-height: 20px;}.cookie-law .cookie-law-wrapper .dismiss svg {  display: block;  fill: #bbb;  width: 20px;  height: 20px;  -webkit-transition: fill .2s;  transition: fill .2s;}.cookie-law .cookie-law-wrapper .copy {  box-sizing: border-box;  padding: 10px 60px 10px 10px;}.cookie-law .cookie-law-wrapper .copy span {  color: #fff;  font-weight: 400;}.cookie-law .cookie-law-wrapper .copy a {  text-decoration: underline;}.cookie-law .cookie-law-wrapper .copy a:active, .copy a:hover {    outline: 0;}@media (min-width: 600px) {  /* For bigger devices: */  .cookie-law .cookie-law-wrapper .copy {    padding: 20px 60px 20px 20px;    font-size: 18px;    line-height: 24px;  }  .cookie-law .cookie-law-wrapper .dismiss {    top: 10px;    right: 15px;  }  .cookie-law .cookie-law-wrapper .dismiss svg {    width: 24px;    height: 24px;  }}'],
        template: '<div class="cookie-law-wrapper" [ngStyle]="currentStyles" [@transition]="transition" (@transition.done)="afterDismissAnimation($event)"><div class="copy"><span #ref><ng-content></ng-content></span><span *ngIf="ref.childNodes.length == 0">By continuing to browse the site, you\'re agreeing to our use of cookies. <span *ngIf="learnMore">Learn more in our <a [href]="learnMore" [target]="target" [rel]="noopener ? \'noopener noreferrer\' : null">privacy policy</a>. </span></span><a href="#" role="button" class="dismiss" [innerHTML]="closeSvg" (click)="dismiss($event)"></a></div></div>',
        encapsulation: ViewEncapsulation.None,
    }),
    __metadata("design:paramtypes", [DomSanitizer])
], CookieLawElementComponent);
export { CookieLawElementComponent };
//# sourceMappingURL=cookie-law-element.component.js.map


// WEBPACK FOOTER //
// ./node_modules/angular2-cookie-law/lib/cookie-law-element.component.js.pre-build-optimizer.js